<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="80px" :model="formLabelAlign">
      <el-form-item label="方案名称">
        <el-input v-model="formLabelAlign.name" />
      </el-form-item>
      <el-form-item label="企业">
        <el-tag v-if="formLabelAlign.corp_id!=''" style="margin-right:10px">{{ corp_name }} ({{ formLabelAlign.corp_id }}) </el-tag>
        <el-button type="warning" size="mini" @click="choose">选择企业</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择企业"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      width="50%"
    >
      <enterprise ref="enterpriseview" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from '../../behavioralsource/components/enterprise.vue'
import { storeTagPlanName } from '@/api/officialaccount.js'
export default {
  components: { enterprise },
  data() {
    return {
      formLabelAlign: {
        name: '',
        corp_id: ''
      },
      corp_name: '',
      dialogVisibler: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async submitForm() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入方案名称')
        return
      }
      if (this.formLabelAlign.corp_id === '') {
        this.$message.error('请选择企业')
        return
      }
      const data = await storeTagPlanName({
        name: this.formLabelAlign.name,
        corp_id: this.formLabelAlign.corp_id,
        status: 2
      })
      console.log('data', data)
      this.$message({
        type: 'success',
        message: '新增方案成功!'
      })
      this.$emit('updata')
    },
    choose() {
      this.dialogVisibler = true
    },
    callback(item) {
      this.dialogVisibler = false
      console.log(item)
      this.corp_name = item.corp_name
      this.formLabelAlign.corp_id = item.corp_id
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
